import React from 'react';

export const BackArrow = (props) => {
  const viewBox = "0 0 21 12"
  const d = "M0.70869 10.6253L1.02383 10.9498C1.2327 11.1649 1.57137 11.1649 1.78029 10.9498L10.4942 1.97851L19.2081 10.9498C19.417 11.1649 19.7557 11.1649 19.9646 10.9498L20.2797 10.6253C20.4886 10.4103 20.4886 10.0616 20.2797 9.84657L10.8724 0.161283C10.6636 -0.053761 10.3249 -0.053761 10.116 0.161283L0.70869 9.84657C0.499773 10.0616 0.499773 10.4103 0.70869 10.6253Z"

  return SVG({props, viewBox, d});
}

const SVG = ({props, viewBox, d, currentColor}) => {
  const {className, width, height, ...style} = props;
  return (
  <svg width={width} height={height} className={className} viewBox={viewBox} style={{...style}}>
    <path d={d} fillRule="evenodd" clipRule="evenodd" fill={currentColor} />
  </svg>
  )
}
